import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import { BASE_URL, TOKEN, CURRENT_IP } from "../../helper/BASE_URL";

export default function Directs() {
  const [data, setData] = useState([]);

  const { t } = useContext(TranslatorContext);

  useEffect(() => {
    Get_Data();
  }, []);

  const Get_Data = () => {
    const getDta = localStorage.getItem("jwt");
    const parseIT = JSON.parse(getDta);

    try {
      axios
        .post(
          BASE_URL + "get_team.php",
          {
            userid: parseIT.reg_em,
            token: parseIT.boss_token,
            ip_addr: window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218',
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data);
          if (
            acc.data.data.team_members_list[0].lvl_members !==
            "NO RECORDS FOUND"
          ) {
            setData(acc.data.data.team_members_list);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <PageLayout>
      <div className="mc-card">
        <div className="mc-breadcrumb">
          <h3 className="mc-breadcrumb-title">{t("Team")}</h3>
          <ul className="mc-breadcrumb-list">
            <li className="mc-breadcrumb-item">
              <Link to="#" className="mc-breadcrumb-link">
                {t("home")}
              </Link>
            </li>
            <li className="mc-breadcrumb-item">{t("Team")}</li>
          </ul>
        </div>
      </div>
      <div className="mc-card p-sm-5">
        <table className="mc-table">
          <thead className="mc-table-head">
            {/* 
          sponser id
sponser name
register date
self team */}
            <tr>
              {/* <th>S.N.</th> */}
              <th>level</th>
              <th>Total Members</th>
              <th>paid members</th>
              {/* <th>self team</th> */}
            </tr>
          </thead>
          <tbody className="mc-table-body">
            {data.map((hit, index) => {
              return (
                <tr key={index}>
                  {/* <td>{index + 1}</td> */}
                  <td>Level {hit.level}</td>
                  <td>{hit.lvl_members}</td>
                  <td>{hit.lvl_paid_members}</td>
                  {/* <td>{hit.self_team}</td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
        {data.length == 0 && (
          <p
            style={{ textAlign: "center", marginTop: 15, fontWeight: "bolder" }}
          >
            No Data Found
          </p>
        )}
      </div>
    </PageLayout>
  );
}
